import { gql } from "@apollo/client";

const GET_CONTRATOS_ASISTENCIAL_BY_PACIENTE = gql`
    query contratosAsistencial($idPaciente: Int!) {
        contratosAsistencial(idPaciente: $idPaciente) {
            idPaciente
            paciente
            sexo
            edad
            idEvaluacion
            fechaDesde
            fechaHasta
            fechaIngreso
            idEstadoEvaluacion
            idEstadoPaciente
            idPlanCuidado
            codigoSap
            nombrePlan
            modulo
            idTipoModulo
            consentimiento
            codigoSAPCliente
            razonSocial
            numeroAfiliado
            tieneTelemedicina
            estadoAsistencial
            observaciones
            tieneSuspensionObito
            poseeEsquema
            origen
            delegacion
            idDelegacion
        }
    }
`;

export default GET_CONTRATOS_ASISTENCIAL_BY_PACIENTE;

export const adaptContratoAsistencial = (contratoAsistencial) => {
  return {
    idPaciente: contratoAsistencial?.idPaciente,
    paciente: contratoAsistencial?.paciente,
    sexo: contratoAsistencial?.sexo,
    edad: contratoAsistencial?.edad,
    idEvaluacion: contratoAsistencial?.idEvaluacion,
    fechaDesde: contratoAsistencial?.fechaDesde,
    fechaHasta: contratoAsistencial?.fechaHasta,
    fechaIngreso: contratoAsistencial?.fechaIngreso,
    idEstadoEvaluacion: contratoAsistencial?.idEstadoEvaluacion,
    idEstadoPaciente: contratoAsistencial?.idEstadoPaciente,
    idPlanCuidado: contratoAsistencial?.idPlanCuidado,
    codigoSap: contratoAsistencial?.codigoSap,
    nombrePlan: contratoAsistencial?.nombrePlan,
    modulo: contratoAsistencial?.modulo,
    idTipoModulo: contratoAsistencial?.idTipoModulo,
    consentimiento: contratoAsistencial?.consentimiento,
    codigoSAPCliente: contratoAsistencial?.codigoSAPCliente,
    razonSocial: contratoAsistencial?.razonSocial,
    numeroAfiliado: contratoAsistencial?.numeroAfiliado,
    telemedicina: contratoAsistencial?.tieneTelemedicina,
    estadoAsistencial: contratoAsistencial?.estadoAsistencial,
    observaciones: contratoAsistencial?.observaciones,
    tieneSuspensionObito: contratoAsistencial?.tieneSuspensionObito,
    planCuidadoPoseeEsquema: contratoAsistencial?.poseeEsquema,
    origen: contratoAsistencial?.origen,
    delegacion: contratoAsistencial?.delegacion,
    idDelegacion: contratoAsistencial?.idDelegacion
  };
};

export const adaptContratosAsistencialArray = (contratosAsistencial) => {
  if (!Array.isArray(contratosAsistencial)) return [];

  return contratosAsistencial.map((contrato) =>
    adaptContratoAsistencial(contrato)
  );
};
